import { useMutation } from 'react-query'

import { fetchInspection } from 'services/inspections'

const useSaveInspection = () => {
  return useMutation(fetchInspection)
}

export default useSaveInspection
